import React from 'react'
import type { Icon } from 'shared/utils'

const King = (props: Icon) => {
    const { color = 'black', size = 24, className = 'king' } = props
    return (
        <svg className={className} width={size} height={size} fill={color}>
            <path
                d="M2 20.686v-9.954L15.192 12v9.953L2 20.686zM15.662 12l6.385-3.474v9.953l-6.385 3.474V12zm5.913-3.832l-5.818 3.175 2.734-4.47 3.084 1.295zM7.681 3.136l9.408.159V5.83l-9.408-.336V3.136zM18.044 6.82a.564.564 0 0 0 .172-.406V2.741a.563.563 0 0 0-.554-.563L7.127 2a.596.596 0 0 0-.405.162.563.563 0 0 0-.168.401v3.15l-.052-.004-4.267 4.554 12.958 1.08 2.824-4.503.027-.021z"
                fillRule="evenodd"
            />
        </svg>
    )
}

export { King }
